var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('app-page-top-section',{attrs:{"title":_vm.$t('contact_us')}}),_vm._v(" "),_c('app-table',{attrs:{"options":_vm.options,"id":"contact-us-table"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }